// extracted by mini-css-extract-plugin
export default {"variantsContainer":"QuestionImgQuiz_variantsContainer__mPypy","blockImgQuestion":"QuestionImgQuiz_blockImgQuestion__mmEfL","variants":"QuestionImgQuiz_variants__zb2Vg"};